import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';
import { SchoolMapItem } from '../../definitions/school-map-item';
import { CommonModule } from '@angular/common';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { Observable, map } from 'rxjs';
import { EducationalFundingMeasureGroup } from '../../definitions/educational-funding-measure-group';
import { filterKeys } from '../../definitions/filter-keys';
import { FilterState } from '@ui/shared/domain-filter';
import { MapItemComponent } from '@ui/shared/util-map';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-school-map-item-filtered-measures',
    templateUrl: './school-map-item-filtered-measures.component.html',
    styleUrls: ['./school-map-item-filtered-measures.component.scss'],
    imports: [
        CommonModule,
        DetailViewModule,
    ],
})
export class SchoolMapItemFilteredMeasuresComponent implements MapItemComponent<SchoolMapItem> {
    public mapItem = input<SchoolMapItem | undefined>();

    @Input()
    public isInPopup = false;

    public visibleMeasureGroups$: Observable<Array<EducationalFundingMeasureGroup>>;

    constructor(
        activeFilterService: FilterState,
    ) {
        this.visibleMeasureGroups$ = activeFilterService.activeFilters$
            .pipe(
                map(activeFilters => ({
                    measureTypeIds: activeFilters.get(filterKeys.measureTypes)?.values.map(value => value.value as number)
                        ?? [],
                    measureStatuses: activeFilters.get(filterKeys.measureStatus)?.values.map(value => value.value as string)
                        ?? [],
                })),
                map(({ measureTypeIds, measureStatuses }) =>
                    // Only if any measure types or statuses are currently filtered, display those measures that match the filter.
                    ((measureTypeIds.length || measureStatuses.length)
                        ? this.mapItem()?.measureGroups
                            .map(measureGroup => ({
                                ...measureGroup,
                                measures: measureGroup.measures
                                    .filter(measure =>
                                        (
                                            measureTypeIds.length
                                                ? measureTypeIds.includes(measure.type)
                                                : true
                                        ) && (
                                            measureStatuses.length
                                                ? measureStatuses.includes(measure.status)
                                                : true
                                        ),
                                    ),
                            }))
                            .filter(measureGroup => measureGroup.measures.length)
                        ?? []
                        : []),
                ),
            );
    }
}
